import * as React from 'react';

import { HeaderLogoAndTel } from '../../../HeaderLogoAndTel';

import * as main from '../styles/main.module.scss';
import * as heroHeader from '../styles/hero.module.scss';

export const HeroHeader = () => {
  return (
    <section className={heroHeader.hero}>
      <div className={'container'}>
        <div className={heroHeader.hero__wrapper}>
          <div className={heroHeader.hero__presentation}>
            <HeaderLogoAndTel />
            <p className={heroHeader.hero__subtitle}>Онлайн-курс</p>
            <h1 className={heroHeader.hero__title}>
              «Английская лексика
              <br />
              для детей»
            </h1>
            <ul className={`${heroHeader.hero__list} ${heroHeader.hero__listAudience}`}>
              <li className={`${heroHeader.hero__element} ${heroHeader.hero__elementOne}`}>
                <p className={heroHeader.hero__text}>
                  Для учеников
                  <br /> <strong>5–7-х классов</strong>
                </p>
              </li>
              <li className={`${heroHeader.hero__element} ${heroHeader.hero__elementTwo}`}>
                <p className={heroHeader.hero__text}>
                  Для тех, кто хочет <br /> <strong>учиться хорошо и ещё лучше</strong>
                </p>
              </li>
            </ul>
            <a className={`${heroHeader.hero__button} ${main.mainBtn}`} href={'#registration'}>
              Регистрация
            </a>
          </div>
          <ul className={`${heroHeader.hero__list} ${heroHeader.hero__listAdvantages}`}>
            <li className={`${heroHeader.hero__element} ${heroHeader.hero__elementThree}`}>
              <p className={heroHeader.hero__text}>
                Учимся <strong>быстро запоминать</strong>
                <br /> английские слова
              </p>
            </li>
            <li className={`${heroHeader.hero__element} ${heroHeader.hero__elementFour}`}>
              <p className={heroHeader.hero__text}>
                Работаем с памятью, чтобы <br />
                <strong>
                  информация оставалась
                  <br />в ней надолго
                </strong>
              </p>
            </li>
            <li className={`${heroHeader.hero__element} ${heroHeader.hero__elementFive}`}>
              <p className={heroHeader.hero__text}>
                Запоминаем <strong>250 английских слов</strong>
                <br /> из разговорной лексики
              </p>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};
